import React, { Fragment, useEffect, useState } from 'react';
import Loader from "react-loader-spinner";


const LoaderForQuery = () => {
    return (
        <div style={{display:'flex', justifyContent:'center', alignItems:'center', height:'85px'}}>
            <Loader
                type="TailSpin"
                color="#E36221"
                height={40}
                width={40}
            // timeout={3000} //3 secs
            />
        </div>
    )
}

const SingleQuery = ({ data, name, onShowMore, handleCheckBox, selectedQueries,loading }) => {
    const [displayValue, setDisplayValue] = useState([]);
    useEffect(() => {
        setDisplayValue(selectedQueries)
    }, [JSON.stringify(selectedQueries)])
    return (
        <Fragment>
            <div style={{ height: '100%' }} className="query-card">
                <div className="query-title-containers ">
                    <p style={{ marginBottom: '0px', textTransform: 'capitalize' }} className="bold">
                        {name}
                    </p>
                </div>
                <div className="query-card__content">
                    {loading ? <LoaderForQuery /> : <div>
                       {data && data?.map((item, index) => {
                            return (
                                <div key={index} className="flex">
                                     <input type="checkbox"
                                        onChange={() => handleCheckBox(item, name)}
                                        checked={
                                            displayValue &&
                                            displayValue.some((q) => {
                                              const a = q?.query?.name || q?.query?.stem_name;
                                              return (
                                                q &&
                                                q.query &&
                                                (q.query.name || q.query.stem_name) &&
                                                a === (item.name || item.stem_name)
                                              );
                                            })
                                          }
                                    /> 
                                    <p style={{ marginLeft: '10px', fontSize: '14px', textTransform:'capitalize' }} className="no-margin-bottom">
                                        {item.stem_name ? item.stem_name : item.name|| item.goal_name}
                                    </p> 
                                </div>
                            )
                        })}
                    </div>}
                </div>
                {/* Show-more removed: lists are scrollable within a fixed-height card */}
            </div>
        </Fragment>
    )
}
export default SingleQuery